/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var allPaymentsBreakdownColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px',
  sm: true
}, {
  name: 'Кр. номер',
  render: function render(data) {
    return ___EmotionJSX(Link, {
      "data-value": "data.number",
      to: "credits/details/".concat(data === null || data === void 0 ? void 0 : data.id)
    }, data.number);
  },
  width: '110px'
}, {
  name: 'Кредитоиск.',
  value: 'borrower_name',
  width: '110px',
  sm: true
}, {
  name: 'Главница',
  render: function render(_ref) {
    var total_principal = _ref.total_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principal"
    }, total_principal, " ", currency);
  },
  md: true
}, {
  name: 'Такси',
  render: function render(_ref2) {
    var total_fee = _ref2.total_fee,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_fee"
    }, total_fee, " ", currency);
  },
  md: true
}, {
  name: 'Лихви',
  render: function render(_ref3) {
    var total_interest = _ref3.total_interest,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interest"
    }, total_interest, " ", currency);
  },
  md: true
}, {
  name: 'Наказ. лихви',
  render: function render(_ref4) {
    var total_penalty = _ref4.total_penalty,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_penalty"
    }, total_penalty, " ", currency);
  },
  lg: true
}, {
  name: 'Общо лихви',
  render: function render(_ref5) {
    var total_interest_all = _ref5.total_interest_all,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interest_all"
    }, total_interest_all, " ", currency);
  },
  lg: true
}, {
  name: 'Сума',
  render: function render(_ref6) {
    var total_amount = _ref6.total_amount,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_amount"
    }, total_amount, " ", currency);
  },
  md: true
}];